/**
 * Study Analytics Page
 */

import {StudyLayout} from '../../components/study/StudyLayout';
import {Container} from '../../components/ui/Container';

export function StudyAnalyticsPage() {
  return (
    <StudyLayout>
      <div className="p-6">
        <Container>
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-textPrimary dark:text-[#CCCCCC] mb-2">
              Analytics
            </h1>
            <p className="text-textSecondary dark:text-[#858585]">
              Track your study progress and performance
            </p>
          </div>

          {/* Placeholder Content */}
          <div className="bg-backgroundSecondary dark:bg-[#252526] rounded-lg border border-gray-200 dark:border-gray-700 p-12 text-center">
            <div className="text-6xl mb-4">📊</div>
            <h2 className="text-xl font-semibold text-textPrimary dark:text-[#CCCCCC] mb-2">
              Analytics coming soon
            </h2>
            <p className="text-textSecondary dark:text-[#858585]">
              View insights about your study habits and progress
            </p>
          </div>
        </Container>
      </div>
    </StudyLayout>
  );
}

